// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2-xng","title":"AfterBackImages_title__1AngH","images":"AfterBackImages_images__3OlUz"};